module.exports = __webpack_public_path__ + "img/建模看板select.69739750.svg";